// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=_v-b5806ea4&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/companies/CompanyBlock.vue
// module id = 455
// module chunks = 0